const columns = {
  status: { id: "status", name: "", sortable: false, deselectable: false },
  starts_at: { id: "starts_at", name: "Starts", sortable: false, deselectable: false },
  lesson: { id: "lesson", name: "Lesson", sortable: false, deselectable: false },
  student: { id: "student", name: "Student", sortable: false, deselectable: false },
  parent: { id: "parent", name: "Guardian", sortable: false, deselectable: false },
  meeting_type: { id: "meeting_type", name: "Type", sortable: false, deselectable: true },
  comments: { id: "comments", name: "Comments", sortable: false, deselectable: true },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false, align: "text-end" },
}

const defaultColumns = [
  "status",
  "starts_at",
  "lesson",
  "student",
  "parent",
  "meeting_type",
  "comments",
  "actions",
]

const downloadOptions = [{ key: "xls", name: "Download All XLS" }]

const filters = [
  {
    section: "Slot Status",
    items: {
      available: { id: "available", name: "Available", dotColor: "available" },
      booked: { id: "booked", name: "Booked", dotColor: "booking" },
      disabled: { id: "disabled", name: "Disabled", dotColor: "disabled" },
    }
  },
  {
    section: "Attendance Status",
    items: {
      attended: { id: "attended", name: "Attended", dotColor: "attended" },
      absent: { id: "absent", name: "Absent", dotColor: "absent" },
      unknown: { id: "unknown", name: "Unknown", dotColor: "unknown" },
    }
  }
]

const filterConditions = {
  "booked": (slot) => slot.slot_status === "Booked",
  "available": (slot) => slot.slot_status === "Available",
  "disabled": (slot) => slot.slot_status === "Disabled",
  "attended": (slot) => slot.attendance_status === "Attended",
  "absent": (slot) => slot.attendance_status === "Absent",
  "unknown": (slot) => slot.slot_status === "Booked" && slot.attendance_status === "Unknown",
}

export { columns, defaultColumns, downloadOptions, filters, filterConditions }